<template>
  <div>
    <!-- <el-dialog
      class="public-dialog"
      :visible.sync="dialogOpen"
      width="52%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :title="title"
      @close="createppFormClosed"
    > -->
    <el-form
      ref="createppFormRef"
      :rules="createppFormRules"
      :model="form"
      label-width="135px"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="活动名称" prop="campaignName">
            <el-input
              :disabled="flag == 3"
              v-model="form.campaignName"
              style="width: 50%"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="活动时间 从" prop="startDate">
            <el-date-picker
              :disabled="flag == 3"
              style="width: 50%"
              v-model="form.startDate"
              type="date"
              placeholder="开始日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="(含) 至" prop="endDate">
            <!-- <span>(含)&nbsp;&nbsp;至</span> -->
            <el-date-picker
              :disabled="flag == 3"
              style="width: 50%"
              v-model="form.endDate"
              type="date"
              placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="领用限制" prop="actLimit">
            <el-radio-group :disabled="flag == 3" v-model="form.actLimit">
              <el-radio :label="0">无限制</el-radio>
              <el-form-item :prop="islimitNum">
                <el-radio :label="3"
                  >每人限制领用
                  <el-input
                    v-model="form.limitNum"
                    :disabled="flag == 3 ? true : form.actLimit != 3"
                    style="margin-left: 10px; width: 25%"
                  ></el-input>
                  <span style="margin-left: 10px">次</span>
                </el-radio>
              </el-form-item>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="活动类容" prop="compaignKind">
            <el-radio-group :disabled="flag == 3" v-model="form.compaignKind">
              <el-radio :label="7">品牌Friends现金礼券</el-radio>
            </el-radio-group>
            <!-- <el-radio>品牌Friends现金礼券</el-radio> -->
            <span style="color: rgb(135, 232, 235); margin-left: 10px"
              >说明：默认选中</span
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="券库" prop="couponsName">
            <div class="xiabiao">
              <el-input
                readonly
                v-model="form.couponsName"
                style="width: 50%"
                @click.native="Quankubtn"
              ></el-input>
              <el-button @click="Selectqk" :disabled="flag == 3">选择</el-button>
              <span style="color: rgb(135, 232, 235)"
                >说明：选择GIADA Fridends券库</span
              >
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="发放数量" prop="sendMaxQty" >
            <el-input :disabled="flag == 3" v-model="form.sendMaxQty" style="width: 50%" placeholder="如果填0则表示不限制发放数量"></el-input>
            <span style="color: rgb(135, 232, 235)">
              说明：指"券库"或者"券包"的发放数量。
            </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="flag == 3">
        <el-col :span="24">
          <el-form-item label="小程序领券链接">
            <el-input
            :disabled="flag == 3"
              readonly
              style="width: 90%"
              v-model="form.coupURL"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="flag == 3">
        <el-col :span="24">
          <el-form-item label="二维码">
            <el-image
            :disabled="flag == 3"
              style="
                width: 150px;
                height: 150px;
                margin: 5px 10px 0 0;
                border: 1px solid #e4e7ed;
              "
              :src="form.coupQRCode"
              :preview-src-list="[form.coupQRCode]"
            ></el-image>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="发放方式">
            <el-radio-group
                :disabled="flag == 3"
                v-model="form.sendMode"
                @change="sendModeRadioChange"
            >
              <el-radio :label="0">立即发送</el-radio>
              <el-radio :label="1">定时发送</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item style="width: 57%" label="发放间隔天数"
                        :rules="
              form.sendMode == 1
                ? [
                    {
                      required: true,
                       message: '请输入发放间隔天数',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <el-input
                oninput="value=value.replace(/[^0-9]/g,'')"
                :disabled="
                flag == 3 ? true : form.sendMode == 1 ? false : true
              "
                v-model="form.disIntervalDay"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item
              label="定时发送时间点"
              prop="issueTime"
              :rules="
              form.sendMode == 1
                ? [
                    {
                      required: true,
                      message: '请选择定时发送时间',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <el-time-picker
                value-format="HH:mm:ss"
                style="width: 36%; margin-left: 10px"
                v-model="form.issueTime"
                placeholder="任意时间点"
                :disabled="
                flag == 3 ? true : form.sendMode == 1 ? false : true
              "
            >
            </el-time-picker>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="flag != 3" @click="create">保存</el-button>
      <el-button @click="close">取消</el-button>
    </div>
    <!-- </el-dialog> -->
    <!-- 选择劵库弹窗 -->
    <div class="choice">
      <el-dialog
        append-to-body
        width="40%"
        title="选择券库"
        :visible.sync="innerVisiblepp"
        :close-on-click-modal="false"
      >
        <el-form size="mini" label-width="120px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="券名称">
                <el-input v-model="queryArr.couponsName"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="券类型">
                <div class="flex-between">
                  <el-select style="width: 100%" v-model="queryArr.couponsKind">
                    <el-option label="全部" value=""> </el-option>
                    <el-option label="现金券" value="0"> </el-option>
                    <el-option label="折扣券" value="1"> </el-option>
                    <el-option label="礼品券" value="2"> </el-option>
                    <el-option label="异业券" value="3"> </el-option>
                  </el-select>
                  <el-button
                    icon="el-icon-search"
                    style="margin-left: 3%"
                    @click="Seachbtn"
                    >查询</el-button
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="创建时间">
                <el-date-picker
                  v-model="queryArr.createTime"
                  type="date"
                  placeholder="选择时间"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="至">
                <el-date-picker
                  v-model="queryArr.updateTime"
                  type="date"
                  placeholder="选择时间"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="width: 100%; margin-top: 10px">
          <el-table
            height="300"
            class="table-style"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTable"
            :data="queryList"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="load"
            v-loading="loading"
            infinite-scroll-disabled="onLoading"
          >
            <el-table-column width="40">
              <template slot-scope="scope">
                <el-radio
                  v-model="radioId"
                  :label="scope.$index"
                  @change.native="handleRadioChange(scope.row)"
                  >&nbsp;
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="couponsName" label="券名称">
            </el-table-column>
            <el-table-column prop="innerCoupName" label="券后台名称">
            </el-table-column>
            <el-table-column prop="couponsKind" label="券类型">
              <template scope="scope">
                {{ scope.row.couponsKind === 0 ? "GIADA Fridends券" : "" }}
              </template>
            </el-table-column>
            <el-table-column prop="coupValue" label="券值"></el-table-column>
            <el-table-column prop="giftNo" label="礼品编号"></el-table-column>
            <el-table-column prop="giftName" label="礼品名称"></el-table-column>
            <el-table-column prop="createUserName" label="创建人">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间">
              <template scope="scope">
                {{ scope.row.createTime | dateFormats }}
              </template>
            </el-table-column>
          </el-table>
          <el-alert
            v-if="isMore"
            title="没有更多啦!"
            type="warning"
            center
            show-icon
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="determine">确 定</el-button>
          <el-button @click="innerVisiblepp = false">取 消</el-button>
        </div>
      </el-dialog>
      <div>
        <el-dialog
          append-to-body
          width="80%"
          title="券库详情"
          :visible.sync="quankuShow"
          :close-on-click-modal="false"
        >
          <quanku ref="quanku"></quanku>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  couponsGroupApi,
  marketingInsertApi,
  marketingEitApi,
} from "@/api/marketing";
import { dateTimes } from "@/utils/auth";
import quanku from "/src/components/quanku.vue";
export default {
  components: {
    quanku: quanku,
  },
  data() {
    return {
      quankuShow: false,
      title: "",
      dialogOpen: false,
      display: false,
      sendMode: 0,
      disIntervalDay: 0,
      issueTime: "",
      saleLimieFlag: 0,
      form: {
        coupQRCode: "",
        coupURL: "",
        campaignName: "", // 活动名称
        startDate: "", // 活动开始日期
        endDate: "", // 活动结束日期
        actLimit: "", // 领用限制
        limitNum: "", // 限制次数
        compaignKind: 7, // 活动类容
        couponsName: "", // 券库名字
        couponsKind: "", // 券类型
        presentedObjID: "", // 券库ID
        sendMaxQty: "", //发放数量
        campaignID: "",
        state: "",
        sendMode: 0,
        disIntervalDay: 0,
        issueTime: "",
        saleLimieFlag: 0,
      },
      flag: "",
      // 选择券库
      innerVisiblepp: false,
      // 选择券库loading
      loading: false,
      //选择劵库弹窗数据
      queryList: [],
      // 内层弹窗请求数据
      queryArr: {
        state:0,
        couponsName: "", //卷名称
        couponsKind: "", //卷类型
        createTime: "",
        updateTime: "",
        pageSize: 50,
        pageNo: 1,
        pages: 0,
        isGFCoup: true,
      },
      // 券库分类ID
      couponsKindID: "",
      // 选择券库radio数据
      radioId: "",
      templatei: "",
      createppFormRules: {
        campaignName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "请选择活动开始时间", trigger: "blur" },
        ],
        endDate: [
          { required: true, message: "请选择活动结束时间", trigger: "blur" },
        ],
        actLimit: [
          { required: true, message: "请选择领用限制", trigger: "blur" },
        ],
        limitNum: [
          { required: true, message: "请输入限制天数", trigger: "blur" },
        ],
        presentedObjname: [
          { required: true, message: "请选择券库", trigger: "blur" },
        ],
        sendMaxQty: [
          { required: true, message: "请输入发放数量", trigger: "blur" },
        ],
        couponsName: [
          { required: true, message: "请选择券库", trigger: "change" },
        ],
      },

    };
  },
  computed: {
    ...mapState(["confirmButtonText", "cancelButtonText"]),
    // 选择券库弹窗
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.queryArr.pageNo >= this.queryArr.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    islimitNum() {
      if (this.form.actLimit == "3") {
        return "limitNum";
      } else {
        return "Str";
      }
    },
  },
  created() {},
  methods: {
    close() {
      this.$emit("close");
    },
    create() {
      this.$refs.createppFormRef.validate((valid) => {
        if (!valid) return true;
        this.createqq();
      });
    },
    createqq() {
      let data = {
        campaignName: this.form.campaignName,
        startDate:
          this.form.startDate != ""
            ? dateTimes(this.form.startDate)
            : undefined, // 活动开始日期
        endDate:
          this.form.endDate != "" ? dateTimes(this.form.endDate) : undefined, // 活动结束日期
        actLimit: this.form.actLimit,
        limitNum: this.form.actLimit == "3" ? this.form.limitNum : undefined,
        compaignKind: this.form.compaignKind,
        presentedObjID: this.form.presentedObjID,
        sendMaxQty: this.form.sendMaxQty,
        // 固定传0
        presentedKind: 0,
        sendMode: this.form.sendMode,
        saleLimieFlag: 0, //定时发放时销售单限制
        disIntervalDay:
            this.form.sendMode == 1
                ? this.form.disIntervalDay
                : null,
        issueTime:
            this.form.sendMode == 1 ? this.form.issueTime : null, //执行时间
      };
      console.log(data);
      if (this.flag == 2) {
        data.campaignID = this.form.campaignID;
        data.state = this.form.state;
        marketingEitApi(data).then((res) => {
          if (res.success !== true) {
            this.$message.error("修改活动失败!");
            return;
          } else {
            this.$message.success("修改活动成功!");
            this.$emit("success");
          }
        });
      } else {
        marketingInsertApi(data).then((res) => {
          if (res.success !== true) {
            this.$message.error("创建活动失败!");
            return;
          }
          {
            this.$message.success("创建活动成功!");
            // 隐藏创建弹窗
            this.$emit("success");
          }
        });
      }
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    handleClose() {
      this.dialogOpen = false;
    },
    // 监听弹窗关闭事件
    createppFormClosed() {
      this.$refs.createppFormRef.resetFields();
      this.flag = "";
    },
    // 选择券库事件
    Selectqk() {
      this.Securitieslibrarypp();
      this.innerVisiblepp = true;
    },
    //选择劵库数据请求
    async Securitieslibrarypp() {
      await couponsGroupApi(this.queryArr).then((res) => {
        this.queryList = res.data.list;
        this.queryArr.pages = res.data.pages;
        this.loading = false;
      });
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.queryArr.pageSize += 50; //页数据+50
        this.Securitieslibrarypp(); // 重新获取数据，此时页数据+50
      });
    },
    //查询
    Seachbtn() {
      this.Securitieslibrarypp();
    },
    // 选择券库弹窗radio选中数据
    handleRadioChange(val) {
      console.log(val);
      this.templatei = val;
    },
    // 选择券库确定事件
    determine() {
      this.form.couponsKind = this.templatei.couponsKind;
      this.form.couponsName = this.templatei.couponsName;
      this.form.presentedObjID = this.templatei.couponsGrpID;
      this.radioId = "";
      this.innerVisiblepp = false;
    },
    // 券库点击跳转
    Quankubtn() {
      if (this.form.presentedObjID) {
        this.quankuShow = true;
        this.$nextTick(() => {
          this.$refs.quanku.RcouponsGroupDetail(this.form.presentedObjID);
        });
      } else {
        return;
      }
      // if (this.form.couponsName !== "") {
      //     this.$router.push({
      //       path: "/GiadaFriendsSee",
      //       query: {
      //         mm: this.form.presentedObjID,
      //       },
      //     });
      // }
    },
    // 处理回显数据
    chulishuju6(res) {
      if (res.flag == 2 || res.flag == 3) {
        this.flag = res.flag;
        this.form.campaignID = res.data.campaignID;
        this.form.state = res.data.state;
      }
      this.form = res.data;
    },
    sendModeRadioChange(index) {

      if (index == 0) {
        this.form.disIntervalDay = '';
        this.form.issueTime = '';

      } else {

        this.form.disIntervalDay = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  height: 40px;
  display: flex;
  justify-content: space-around;
}
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
.el-dialog__header {
  background-color: #f3f1dd;
}
.el-dialog__title {
  font-size: 14px;
  font-weight: 700;
  color: #6c6937;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
.el-button:hover {
  background-color: #b5b386;
  color: #f2f2f2;
}
/deep/.xiabiao .el-input .el-input__inner {
  color: blue;
  text-decoration: underline;
}
</style>